//@flow

import React from 'react';

import type { Sauce } from './domain/pizza';
import { impossible } from './domain/utils';
import Basil from '../../../../assets/images/pages/pizza/fields/pizza_source_basil@3x.png';
import Tomato from '../../../../assets/images/pages/pizza/fields/pizza_source_tomato@3x.png';
import White from '../../../../assets/images/pages/pizza/fields/pizza_source_white@3x.png';

type Props = {
  sauce: Sauce,
};

export default class PizzaSauce extends React.PureComponent<Props> {
  get imgSrc(): string {
    switch (this.props.sauce) {
      case 'tomato_sauce':
        return Tomato;
      case 'white_sauce':
        return White;
      case 'basil_sauce':
        return Basil;
      default:
        return impossible(this.props.sauce);
    }
  }

  render() {
    // eslint-disable-next-line
    const { sauce, ...rest } = this.props;
    return (
      <div {...rest} className="pizza-image pizza-sauce">
        <img src={this.imgSrc} />
      </div>
    );
  }
}
